import { Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { CustomCmsVideoComponent } from '../../models/cms-links.model'
@Component({
    selector: 'app-shared-video',
    templateUrl: './shared-video.component.html',
    styleUrl: './shared-video.component.scss',
    standalone: false
})
export class SharedVideoComponent implements OnInit {

  public componentData: CustomCmsVideoComponent;

  constructor(public component: CmsComponentData<CustomCmsVideoComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
